export const isAllowed = (user, rights) => {
  if (user.rights !== undefined) {
    return rights.some((right) => user.rights.includes(right));
  }
};

export const hasRole = (user, roles) => {
  if (user.roles !== undefined) {
    return roles.some((role) => user.roles.includes(role));
  }
};

export const hasRoleDOA = (user, doaroles) => {
  if (user.doaroles !== undefined) {
    return doaroles.some((role) => user.doaroles.includes(role));
  }
};
